export default __webpack_public_path__ + "static/media/1184.e8d7a889.jpeg";